import React, { useState } from "react"

// Red banner shown when one of the partner's apps failed to sync. The Re-sync
// button POSTs to the per-app resync endpoint (owner/admin) and reloads so the
// dashboard refetches with fresh figures.
export function SyncFailureBanner({ failure, copy }) {
  const [busy, setBusy] = useState(false)

  const lastSynced = failure.last_synced_at
    ? new Date(failure.last_synced_at).toLocaleString()
    : copy.never

  const appLabel = failure.app_name || failure.app_gid
  const title = copy.title.replace("{app}", appLabel)
  const body = copy.body.replace("{at}", lastSynced)

  const resync = () => {
    setBusy(true)
    const token = document.querySelector("meta[name='csrf-token']")?.content
    fetch(`/partner_apps/${failure.id}/resync`, {
      method: "POST",
      headers: { "X-CSRF-Token": token, Accept: "application/json" },
    })
      .then(() => window.location.reload())
      .catch(() => setBusy(false))
  }

  return (
    <div className="flex flex-col gap-3 rounded-xl border border-red-200 dark:border-red-900/50 bg-red-50 dark:bg-red-950/40 p-4 sm:flex-row sm:items-center">
      <div className="flex min-w-0 flex-1 items-start gap-2">
        <span className="mt-0.5 shrink-0 text-red-500 dark:text-red-400" aria-hidden="true">⚠</span>
        <p className="text-sm text-gray-700 dark:text-gray-300">
          <span className="font-semibold text-gray-900 dark:text-gray-100">{title}</span> {body}
        </p>
      </div>
      <button
        type="button"
        onClick={resync}
        disabled={busy}
        className="shrink-0 self-start rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-700 disabled:opacity-60 sm:self-auto"
      >
        {busy ? copy.resyncing : copy.resync}
      </button>
    </div>
  )
}
